/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AuthApiService } from '../../core/http';
import { BaseComponent } from '../../core/components';
import { Component } from '@angular/core';
import { ErrorResponseModel } from '../../core/models';
import { LogService, NotifyService } from '../../core/services/';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-restart',
    templateUrl: './restart.component.html',
    styleUrls: ['./restart.component.scss', '../externalPageStyles.scss', '../simple-external-page.scss']
})

export class RestartComponent extends BaseComponent {
    /**
     * Displays the current year in the copyright and version footer.
     */
    public currentYear: number = new Date().getFullYear();

    /**
     * Interval Id
     * @private
     */
    private intervalId: any;

    constructor(
        private authApiService: AuthApiService,
        private logService: LogService,
        private notifyService: NotifyService,
        private router: Router
    ) {

        super();

        const stateUser = this.router.getCurrentNavigation()?.extras?.state?.user;
        const user = stateUser ? stateUser : {
            applianceAddress: location.hostname,
            appliancePort: location.port
        };

        const timeoutId = setTimeout(() => {
            this.intervalId = setInterval(() => {
                this.pingBoxViaApi(user, 2000);
            }, 2500);
            clearTimeout(timeoutId);
        }, 15000);
    }

    /**
     * Calls the Ping API to see if the box is online.
     * @param user
     * @param timeLimit
     * @private
     */
    private pingBoxViaApi(user: any, timeLimit: number): void {
        const url = {
            applianceAddress: user.applianceAddress,
            appliancePort: user.appliancePort
        };

        this.authApiService.ping(url, timeLimit)
            .pipe(takeUntil(this.destroyed$))
            .subscribe({
                next: (data: any): void => {
                    if (data) {
                        this.notifyService.success('Your loadbalancer is back online');
                    }
                },
                error: (error: ErrorResponseModel): void => {
                    this.handleLoginError(error);
                    this.logService.error(
                        'ServicesComponent: pingBoxViaApi',
                        'Error pinging the box', error.message
                    );
                }
            });
    }

    /**
     * Handle login error
     * @param error
     * @private
     */
    private handleLoginError(error: any): void {
        if (error.message === 'Verify host certificate authority' || error.message === 'Invalid bearer token.') {
            const timeoutId = setTimeout(() => {
                clearInterval(this.intervalId);
                this.router.navigateByUrl('/login').then();
                clearTimeout(timeoutId);
            }, 5000);
        }
    }
}
